import React, {useRef} from 'react';
import {Button, Space, message} from 'antd';
import {EditOutlined, DeleteOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import SearchTable from '../../components/admin/SearchTable';
import StatusTag from '../../components/admin/StatusTag';
import {useConfirmModal} from '../../components/ConfirmModal';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES, formatPath} from '../../constants/PathRoutes';
import api from '../../services/api';

export default function AdminFAQList() {
    const navigate = useNavigate();
    const tableRef = useRef();
    const {showConfirm, ConfirmModal} = useConfirmModal();

    const handleDelete = async (id) => {
        showConfirm({
            title: 'Excluir FAQ',
            description: 'Tem certeza que deseja excluir esta FAQ?',
            type: 'danger',
            confirmText: 'Excluir',
            cancelText: 'Cancelar',
            onConfirm: async () => {
                try {
                    await api.delete(formatPath(ENDPOINTS.FAQ_DETAIL, {id}));
                    message.success('FAQ excluída com sucesso');
                    tableRef.current?.refetch();
                } catch (error) {
                    message.error('Erro ao excluir FAQ');
                }
            }
        });
    };

    const columns = [

        {
            title: 'Pergunta',
            dataIndex: 'question',
            key: 'question',
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            key: 'is_active',
            width: 100,
            render: (isActive) => <StatusTag isActive={isActive} />,
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        icon={<EditOutlined/>}
                        size="small"
                        onClick={() => navigate(formatPath(ROUTES.ADMIN_FAQ_EDIT, {id: record.id}))}
                    />
                    <Button
                        danger
                        icon={<DeleteOutlined/>}
                        size="small"
                        onClick={() => handleDelete(record.id)}
                    />
                </Space>
            ),
        },
    ];

    return (
        <>
            <SearchTable
                ref={tableRef}
                url={ENDPOINTS.FAQ_LIST}
                columns={columns}
                title="Gerenciamento de FAQs"
                buttonProps={{
                    onClick: () => navigate(ROUTES.ADMIN_FAQ_CREATE),
                    label: 'Nova FAQ',
                }}
            />
            <ConfirmModal />
        </>
    );
}